var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',_vm._b({staticClass:"img-circle",class:_vm.newclass,attrs:{"src":_vm.src},on:{"error":function($event){return _vm.imageonerror($event)}}},'img',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }